module.exports = __webpack_public_path__ + "img/shopping-list (1).e7e32ecd.png";